export const pendingAppoHeaders = ["Appointment Date", "Booking Date", "Status", "Action"]

export const meberHeaders = ["Image", "Member Name", "Blood Group", "Appointments", "Action"]

export const chipVariants = {
  rejected: "red",
  accepted: "green",
  cancelled: "gray",
  late_cancelled: "red",
  expired: "red",
  pending: "orange",
  scheduled: "blue",
  completed: "green",
  no_show_specialist: "yellow",
  no_show_member: "yellow",
  "no-show": "yellow",
}